// proteoformTokens.ts
// Canonical isoform/PTM token set + display order for the Tau proteoform matrix.
// Mirrors TAU_STUB_COLUMNS (TauSamplesDetailTable.tsx — a separate, older, unrelated
// concept, see that file) and the stub columns in RunSampleDetailsSection/colDefs.ts.
// `token` is the segment as it appears inside the composite `proteoform_name` (e.g.
// "N-0N-pT205-3R-C"); `i18nKey` is the existing `runs`-namespace key used for the
// localized column header.
//
// This is only the FALLBACK used while the real assay-driven config (POR-322
// `/assays/{assay_id}/proteoform_results_table_config`, see ProteoformAbundances.tsx /
// RunSampleDetailsSection/colDefs.ts) hasn't loaded yet — once loaded, the real config's
// `key`/`label` fields are authoritative and this constant isn't consulted.
//
// RESOLVED (was a TODO): confirmed against the real backend's Tau assay seed data
// (portal-backend app/api/v1/assays.py, AssayTarget entries) that the PTM segment is
// "pT217", not "p217" — fixed below. (TauSamplesDetailTable.tsx still uses "p217"; that's
// a separate, unrelated component/table — out of scope here, not touched.)
export interface ProteoformToken {
  token: string;
  i18nKey: string;
}

export const PROTEOFORM_TOKENS: readonly ProteoformToken[] = [
  { token: 'N', i18nKey: 'sampleDetails.col_n_terminus' },
  { token: '0N', i18nKey: 'sampleDetails.col_0n' },
  { token: '1N', i18nKey: 'sampleDetails.col_1n' },
  { token: '2N', i18nKey: 'sampleDetails.col_2n' },
  { token: '3R', i18nKey: 'sampleDetails.col_3r' },
  { token: '4R', i18nKey: 'sampleDetails.col_4r' },
  { token: 'C', i18nKey: 'sampleDetails.col_c_terminus' },
  { token: 'pT181', i18nKey: 'sampleDetails.col_pt181' },
  { token: 'pS202+PT205', i18nKey: 'sampleDetails.col_ps202_pt205' },
  { token: 'pT205', i18nKey: 'sampleDetails.col_pt205' },
  { token: 'pS214', i18nKey: 'sampleDetails.col_ps214' },
  { token: 'pT217', i18nKey: 'sampleDetails.col_pt217' },
  { token: 'pT231', i18nKey: 'sampleDetails.col_pt231' },
  { token: 'pS396', i18nKey: 'sampleDetails.col_ps396' },
] as const;
